/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {getIMSConfig} from '@exc/core/src/utils/IMSConfig';

const defaultListeners = [
  ['imslib.accesstoken', 'auth.accesstoken'],
  ['imslib.accesstokenexpired', 'auth.accesstokenexpired']
];
const storedEvents = [];

export function addEvents() {
  defaultListeners.forEach(lt => {
    document.addEventListener(lt[0], () => storedEvents.push(lt[1]));
  });
}
addEvents();

export function loadIMS() {
  return require('@exc/imslib/release/prod/imslib.no-polyfills.min.js');
}

function getEnv(environment) {
  const url = new URL(window.location.href);
  if (url.searchParams.has('shell_ims')) {
    return url.searchParams.get('shell_ims');
  }
  return environment.toLowerCase() === 'prod' ? 'prod' : 'stage';
}

export function initIMS() {
  const env = getEnv((window.config || {}).env);
  const config = getIMSConfig(env);
  window.adobeid = Object.assign({}, config, {
    isFromIMS: window.location.hash.indexOf('from_ims') > -1,
    optimizations: {fastEvents: true},
    storedEvents
  });
  window.adobeid.loadPromise = new Promise(resolve => {
    window.adobeid.onReady = resolve;
    loadIMS();
  });
}
